const elements = Array.from(document.querySelectorAll('.js-toggle'));

elements.forEach((el) => {
    const container = el.querySelector('.js-toggle-container');
    const content = el.querySelector('.js-content');
    const intro = el.querySelector('.js-intro');
    const trigger = el.querySelector('button');
    const text = trigger.querySelector('span');

    let scrollTop;

    container.style.maxHeight = `${container.scrollHeight}px`;

    trigger.addEventListener('mouseover', () => {
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    });

    trigger.addEventListener('click', () => {
        el.classList.toggle('shadow');
        el.classList.toggle('is-open');
        intro.classList.toggle('hidden');
        content.classList.toggle('h-0');

        if (text.innerHTML === 'Read More') {
            text.innerHTML = 'Read Less';
        } else {
            text.innerHTML = 'Read More';
        }

        const height = el.scrollHeight + 50;
        container.style.maxHeight = `${height}px`;

        document.documentElement.scrollTop = document.body.scrollTop = scrollTop;
    });
});
